var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-demo",
      attrs: {
        "default-active": _vm.active,
        mode: "horizontal",
        "background-color": "#545c64",
        "text-color": "#fff",
        "active-text-color": "#409EFF",
        router: ""
      }
    },
    _vm._l(_vm.tabs, function(item) {
      return _c(
        "el-menu-item",
        { key: item.index, attrs: { index: item.index } },
        [_vm._v(_vm._s(item.label))]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b100049", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b100049","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/components/HeaderTabs.vue
// module id = null
// module chunks = 